import Fitty from 'fitty';
import { FC, useEffect, useRef, PropsWithChildren } from 'react';

type Props = {
	minSize: number;
	maxSize: number;
};

const ReactiveText: FC<PropsWithChildren<Props>> = ({ children, ...props }) => {
	const ref = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		if (ref.current) Fitty(ref.current, props);
	}, [ref, props]);

	return <span ref={ref}>{children}</span>;
};

export default ReactiveText;
